'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const modalContentFooter = "_modal-content-footer_16z1m_1";
const styles = {
	modalContentFooter: modalContentFooter
};

const ModalContentFooter = ({ children }) => {
  return React__default.default.createElement("footer", { className: styles.modalContentFooter, "data-zds": true }, children);
};

exports.ModalContentFooter = ModalContentFooter;
//# sourceMappingURL=ContentFooter.cjs.js.map
